<template>
    <div class="publication__search content-width" ref="search">

        <div class="publication__search-selected d-flex" v-if="selectedCities.length">
            <div class="publication__search-selected-item d-flex" v-for="city in selectedCities" >
                <div class="publication__search-selected-name">{{city.name}}</div>
                <span @click.prevent="removeItem( 'city', city.id )">
                        <img src="/assets/images/icons/publication-close.svg" alt="">
                </span>
            </div>
        </div>

        <div class="publication__search-selected d-flex" v-if="selectedRegions.length">
            <div class="publication__search-selected-item d-flex" v-for="region in selectedRegions" >
                <div class="publication__search-selected-name">{{region.name}}</div>
                <span @click.prevent="removeItem('region', region.id )">
                        <img src="/assets/images/icons/publication-close.svg" alt="">
                </span>
            </div>
        </div>

        <div class="publication__search-wrapper">
            <div class="text-danger" v-if="$v.cities.$error">Неверное значение.</div>
            <div class="text-danger" v-if="$v.regions.$error">Неверное значение.</div>
            <div class="publication__search-input" :class="{'publication__search-input--active': search}">
                <input :disabled="!range || (range === 'country' || range === 'abroads')" type="text"
                       :value="search" @input="search = $event.target.value"
                       placeholder="Начните набирать название нас. пункта">
            </div>
            <div class="publication__search-list" v-if="search" ref="searchList">
                <template v-if="items.length">
                    <div class="publication__search-item"
                         :class="{'publication__search-item--selected':
                         range === 'region' && selectedRegions.length ? selectedRegions.some( e => e.id === item.id ) :
                         range === 'city' && selectedCities.length ? selectedCities.some( e => e.id === item.id ) : false }"
                         @click.prevent="setItem(item)" v-for="item in items" >{{ item.name }}</div>
                </template>
                <template v-if="!items.length && search">
                    <div class="publication__search-empty">Ничего не найдено</div>
                </template>
            </div>

        </div>

    </div>
</template>

<script>

import { required, requiredIf, minLength } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";
import catalog from "../../../store/catalog";

export default {
    name: "SelectLocation",
    props: ['server'],
    mixins: [StateMixin],
    data(){
        return{
            search: null,
            items: [],
        }
    },

    computed: {

        selectedCities: {
            get(){ return this.GET_BY_KEY('selectedCities') },
            set( val ) {
                this.SET_BY_KEY({ key: 'selectedCities', data: val })
            }
        },

        selectedRegions: {
            get(){ return this.GET_BY_KEY('selectedRegions') },
            set( val ) {
                this.SET_BY_KEY({ key: 'selectedRegions', data: val })
            }
        },

        cities: {
            get(){ return this.GET_BY_KEY('cities') },
            set( val ) {
                this.SET_BY_KEY({ key: 'cities', data: val })
            }
        },

        regions: {
            get(){ return this.GET_BY_KEY('regions') },
            set( val ) {
                this.SET_BY_KEY({ key: 'regions', data: val })
            }
        },

        range: {
            get() { return this.GET_BY_KEY('range') },
            set( val ) {
                this.SET_BY_KEY({ key: 'range', data: val })
            }
        },

    },

    watch: {
        search( val ){

            if( ! val ) {
                this.handleHeight()
                this.items = [];
                return;
            }

           this.searchMethod();

        },

        selectedCities(){
            this.cities = this.selectedCities.map( e =>  e.id );
        },

        selectedRegions(){
            this.regions = this.selectedRegions.map( e =>  e.id );
        },


    },

    methods: {

        async searchMethod() {

            try{

                let  url =  this.range && this.range === 'region' ? `/api/locations/regions` : `/api/locations/cities`,
                    params = {
                        query: this.search
                    };

                const { data: { data = [], success = false } } = await axios.get( url, { params: params } );

                if( success ) {
                    new Promise( res => {
                        this.items = data;
                        res();
                    } ).then( () => { this.handleHeight() } );
                }

            } catch ( _e ){

                console.log( _e );

            }

        },

        handleHeight(){
            this.$parent.handleSliderHeight()
        },

        removeItem( type, _target ){

            if( type === 'city' ){

                this.selectedCities = this.selectedCities.filter( e => e.id !== _target );

                if( ! this.selectedCities.length ) {
                    this.items = [];
                    this.range = null;
                }

                return;
            }

            if( type === 'region' ){

                this.selectedRegions = this.selectedRegions.filter( e => e.id !== _target );

                if( ! this.selectedRegions.length ) {
                    this.items = [];
                    this.range = null;
                }

                return;
            }


        },

        setItem( _target ){

            new Promise( res => {

                if( this.range === 'city' ) this.selectedCities.push( _target )
                if( this.range === 'region' ) this.selectedRegions.push( _target )

                this.search = null;
                this.items = [];

                res();
            } ).then( () => { this.handleHeight() } )

        },

        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true
        }


    },

    validations: {

        cities: {
            required: requiredIf( function() {
                return this.range === 'city'
            } ),
        },

        regions: {
            required: requiredIf( function() {
                return this.range === 'region'
            } ),
        },

    }

}
</script>

<style scoped>

</style>
